import SetUpdatedAtCols from './SetUpdatedAtCols';
import ToggleNewData from './ToggleNewData';
import UpdateTotals from './UpdateTotals';

// Fill a column's top cell data down to subsequent rows
export default function(el) {

  // Get index of current column in table 
  let colId = el.closest('th').attr('data-column-id');

  // Get value from first row in this column
  let firstVal = '';
  let tr = el.closest('table').find('tbody tr')[0];
  let cell = $(tr).find('td[data-column-id=' + colId + ']');
  if (cell) {
    let input = $(cell).find('input.answer-text');
    let select = $(cell).find('select.answer-text');
    let textarea = $(cell).find('textarea.answer-text');
    if (input.length !== 0) {
      let val = input.val();
      if (!val) {
        let ttInput = $(cell).find('.twitter-typeahead .tt-input');
        if (ttInput.length) {
          val = ttInput.val();
        }
      }
      if (val) {
        firstVal = val;
      }
    } else if (select.length !== 0) {
      let val = select.val();
      if (val) {
        firstVal = val;
      }
    } else if (textarea.length !== 0) {
      let val = textarea.val();
      if (val) {
        firstVal = val;
      }
    }
  }

  // Fill all rows with firstVal
  el.closest('table').find('tbody tr').each(function() {
    let isTotal = $(this).attr('data-total-row');
    if (isTotal === 'true') {return;}
    let rowIndex = $(this).index();
    if (rowIndex === 0) {return;}
    let relatedTd = $(this).find('td[data-column-id=' + colId + ']');
    let input = $(relatedTd).find('input.answer-text');
    let textarea = $(relatedTd).find('textarea.answer-text');
    let select = $(relatedTd).find('select.answer-text');
    if (input.length !== 0) {
      input.val(firstVal).trigger('change');
      input.typeahead('val', firstVal);
      ToggleNewData(input);
      SetUpdatedAtCols(input);
      // Also set value on .tt-input if present
      let ttInput = $(relatedTd).find('.twitter-typeahead .tt-input');
      if (ttInput.length) {
        ttInput.val(firstVal).trigger('change');
        ttInput.typeahead('val', firstVal);
      }
    } else if (select.length !== 0) {
      select.val(firstVal).trigger('change');
      ToggleNewData(select);
      SetUpdatedAtCols(select);
    } else if (textarea.length !== 0) {
      textarea.val(firstVal).trigger('change');
      ToggleNewData(textarea);
      SetUpdatedAtCols(textarea);
    }
    if (firstVal.length > 0) {
      $(relatedTd).find('.answer-text').addClass('filled');
    } else {
      $(relatedTd).find('.answer-text').removeClass('filled');
    }

    // Update totals if needed
    let answerText = $(relatedTd).find('.answer-text');
    UpdateTotals(answerText);

  });

  // Hide tooltips
  el.tooltip('hide');
}